"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIMARY_CONTAINER_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.primaryContainer,
    skipImportingInCMS: true,
}, {
    tpdRegistrazioneClientiContainer: {
        __mfeName__: "tpdRegistrazioneClientiContainer",
        devClientPort: 3025,
        devServerPort: 3025,
        portlet: {
            path: "UnipolSai-Disegno-SelfRegistration / PT_registrazione_clienti",
            uniqueName: "unipolsai.areariservata.selfregwidget.registrazionecliente",
            title: "Registrazione_Clienti",
        },
    },
    tpdPreventivatoreStickyContainer: {
        __mfeName__: "tpdPreventivatoreStickyContainer",
        devClientPort: 3045,
        devServerPort: 3045,
        mfePriority: 2000,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Maschera_Preventivo",
            uniqueName: "unipolSai.portlet.hpMascheraPreventivo",
            title: "Maschera_Preventivo",
        },
    },
    tpdPreventiviContainer: {
        __mfeName__: "tpdPreventiviContainer",
        devClientPort: 3060,
        devServerPort: 3060,
        mfePriority: 1900,
        portlet: {
            path: "UnipolSai-Disegno-Preventivi / PT_widget_preventivi",
            uniqueName: "unipolSai.portlet.wdgHomePreventivi",
            title: "Widget_Home_Preventivi",
        },
    },
    tpdLeTuePolizzeContainer: {
        __mfeName__: "tpdLeTuePolizzeContainer",
        devClientPort: 3064,
        devServerPort: 3064,
        portlet: {
            path: "UnipolSai-Disegno-HomePageAreaRiservata / PT_le_tue_polizze",
            uniqueName: "unipolsai.areariservata.homewidget.letuepolizze",
            title: "Le_Tue_Polizze",
        },
    },
    tpdDisambiguazioneContainer: {
        __mfeName__: "tpdDisambiguazioneContainer",
        devClientPort: 3082,
        devServerPort: 3082,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_tpdPaginaDisambiguazioneContainer",
            uniqueName: "unipolsai.portlet.tpdPaginaDisambiguazioneContainer",
            title: "tpdPaginaDisambiguazioneContainer",
        },
    },
    tpdLaTuaAgenziaContainer: {
        __mfeName__: "tpdLaTuaAgenziaContainer",
        devClientPort: 3084,
        devServerPort: 3084,
        portlet: {
            path: "UnipolSai-Disegno-HomePageAreaRiservata / PT_la_tua_agenzia",
            uniqueName: "unipolsai.areariservata.homewidget.latuaagenzia",
            title: "La_Tua_Agenzia",
        },
    },
    tpdConfermaRegistrazioneContainer: {
        __mfeName__: "tpdConfermaRegistrazioneContainer",
        devClientPort: 3088,
        devServerPort: 3088,
        portlet: {
            path: "UnipolSai-Disegno-SelfRegistration / PT_conferma_registrazione",
            uniqueName: "unipolsai.areariservata.selfregwidget.registrazionecliente",
            title: "Registrazione_Clienti",
        },
    },
    tpdTagUtileASapersiContainer: {
        __mfeName__: "tpdTagUtileASapersiContainer",
        devClientPort: 3117,
        devServerPort: 3117,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / Utile a Sapersi / PT_Tag_Utile_A_Sapersi_Container",
            uniqueName: "unipolSai.portlet.tagUtileASapersi",
            title: "Contenitore_Tag_Utile_A_Sapersi",
        },
    },
    tpdTelematicaContainer: {
        __mfeName__: "tpdTelematicaContainer",
        devClientPort: 3185,
        devServerPort: 3185,
        portlet: {
            path: "UnipolSai-Disegno-Telematici / PT_unibox",
            uniqueName: "unipolsai.areariservata.telematica.unibox",
            title: "Unibox",
        },
    },
    tpdAcquisto: {
        __mfeName__: "tpdAcquisto",
        devClientPort: 3202,
        devServerPort: 3202,
        portlet: {
            path: "UnipolSai-Disegno-Preventivi / PT_acquisto",
            uniqueName: "unipolsai.areariservata.preventivi.acquistopolizza",
            title: "Acquisto_Polizza",
        },
    },
    tpdDocumentazione: {
        __mfeName__: "tpdDocumentazione",
        devClientPort: 3203,
        devServerPort: 3203,
        portlet: {
            path: "UnipolSai-Disegno-Preventivi / PT_documentazione",
            uniqueName: "unipolsai.areariservata.preventivi.documentazioneacquistopolizza",
            title: "Documentazione_Acquisto_Polizza",
        },
    },
    tpdSpedizionePolizza: {
        __mfeName__: "tpdSpedizionePolizza",
        devClientPort: 3204,
        devServerPort: 3204,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_spedizione_polizza",
            uniqueName: "unipolsai.areariservata.polizze.spedizionepolizza",
            title: "Spedizione_Polizza",
        },
    },
    tpdEsitoAcquisto: {
        __mfeName__: "tpdEsitoAcquisto",
        devClientPort: 3205,
        devServerPort: 3205,
        portlet: {
            path: "UnipolSai-Disegno-Preventivi / PT_esito-acquisto",
            uniqueName: "unipolsai.areariservata.preventivi.esitoacquistopolizza",
            title: "Esito_Acquisto_Polizza",
        },
    },
    tpdLoginHeaderContainer: {
        __mfeName__: "tpdLoginHeaderContainer",
        devClientPort: 3206,
        devServerPort: 3206,
    },
    tpdCauzioni: {
        __mfeName__: "tpdCauzioni",
        devClientPort: 3207,
        devServerPort: 3207,
        portlet: {
            path: "UnipolSai-Disegno-Quotatori / PT_Cauzioni",
            uniqueName: "unipolsai.portlet.cauzioni",
            title: "Cauzioni",
        },
    },
    tpdTelepedaggioPurchase: {
        __mfeName__: "tpdTelepedaggioPurchase",
        devClientPort: 3210,
        devServerPort: 3210,
        portlet: {
            path: "UnipolSai-Disegno-Telepedaggio / PT_Telepedaggio_Purchase",
            uniqueName: "unipolSai.portlet.telepedaggioAcquisto",
            title: "Telepedaggio Purchase	Acquisto",
        },
    },
    tpdApriSegnalazione: {
        __mfeName__: "tpdApriSegnalazione",
        devClientPort: 3211,
        devServerPort: 3211,
        portlet: {
            path: "UnipolSai-Disegno-Telepedaggio / PT_Apri_Segnalazione",
            uniqueName: "unipolSai.portlet.apriSegnalazioneTelepedaggio",
            title: "Apri Segnalazione	Telepedaggio",
        },
    },
    tpdTelepedaggioModificaOfferta: {
        __mfeName__: "tpdTelepedaggioModificaOfferta",
        devClientPort: 3212,
        devServerPort: 3212,
        portlet: {
            path: "UnipolSai-Disegno-Telepedaggio / PT_Telepedaggio_Modifica_Offerta",
            uniqueName: "unipolSai.portlet.telepedaggioModificaOfferta",
            title: "Telepedaggio Modifica	Offerta",
        },
    },
    tpdTelepedaggioDashboard: {
        __mfeName__: "tpdTelepedaggioDashboard",
        devClientPort: 3213,
        devServerPort: 3213,
        portlet: {
            path: "UnipolSai-Disegno-Telepedaggio / PT_Telepedaggio_Dashboard",
            uniqueName: "unipolSai.portlet.telepedaggioDashboard",
            title: "Telepedaggio Dashboard+",
        },
    },
    tpdTelepedaggioAttivazioneMandatoSDD: {
        __mfeName__: "tpdTelepedaggioAttivazioneMandatoSDD",
        devClientPort: 3214,
        devServerPort: 3214,
        portlet: {
            path: "UnipolSai-Disegno-Telepedaggio / PT_Telepedaggio_Attivazione_Mandato_SDD",
            uniqueName: "unipolSai.portlet.telepedaggioAttivazioneMandato",
            title: "Telepedaggio Attivazione	Mandato	sdd",
        },
    },
    tpdTelepedaggioWidgetHomepage: {
        __mfeName__: "tpdTelepedaggioWidgetHomepage",
        devClientPort: 3215,
        devServerPort: 3215,
    },
    tpdTelepedaggioWidgetPolizzeCollettive: {
        __mfeName__: "tpdTelepedaggioWidgetPolizzeCollettive",
        devClientPort: 3216,
        devServerPort: 3216,
    },
    tpdTelepedaggioLanding: {
        __mfeName__: "tpdTelepedaggioLanding",
        devClientPort: 3217,
        devServerPort: 3217,
    },
    tpdInserimentoPin: {
        __mfeName__: "tpdInserimentoPin",
        devClientPort: 6218,
        devServerPort: 6218,
        portlet: {
            path: "UnipolSai-Disegno-Account / PT_inserimento_pin",
            uniqueName: "unipolsai.areariservata.account.inserimentorichiestapin",
            title: "Inserimento_Richiesta_Pin",
        },
    },
    tpdFormIniziative: {
        __mfeName__: "tpdFormIniziative",
        devClientPort: 3221,
        devServerPort: 3221,
        portlet: {
            path: "UnipolSai-Disegno-Iniziative / PT_Form_Iniziative",
            uniqueName: "unipolSai.portlet.formIniziative",
            title: "Form_Iniziative",
        },
    },
    tpdRiepilogoIniziative: {
        __mfeName__: "tpdRiepilogoIniziative",
        devClientPort: 3222,
        devServerPort: 3222,
        portlet: {
            path: "UnipolSai-Disegno-Iniziative / PT_Riepilogo_Iniziative",
            uniqueName: "unipolSai.portlet.riepilogoIniziative",
            title: "Riepilogo_Iniziative",
        },
    },
    tpdGestioneUtenzeAziendaliDisabilitazione: {
        __mfeName__: "tpdGestioneUtenzeAziendaliDisabilitazione",
        devClientPort: 3223,
        devServerPort: 3223,
    },
    tpdVenditaIbridaUnsubscribe: {
        __mfeName__: "tpdVenditaIbridaUnsubscribe",
        devClientPort: 3225,
        devServerPort: 3225,
        portlet: {
            path: "UnipolSai-Disegno-Vendita-Ibrida / PT_Vendita_Ibrida_Unsubscribe",
            uniqueName: "unipolSai.portlet.venditaIbridaUnsubscribe",
            title: "Vendita_Ibrida_Unsubscribe",
        },
    },
    tpdGestioneComunicazioni: {
        __mfeName__: "tpdGestioneComunicazioni",
        devClientPort: 3229,
        devServerPort: 3229,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Gestione_Comunicazioni",
            uniqueName: "unipolSai.portlet.gestioneComunicazioni",
            title: "Gestione_Comunicazioni",
        },
    },
    tpdComunicazioniConCta: {
        __mfeName__: "tpdComunicazioniConCta",
        devClientPort: 3232,
        devServerPort: 3232,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Comunicazioni_Con_Cta",
            uniqueName: "unipolSai.portlet.comunicazioniConCta",
            title: "Comunicazioni_Con_Cta",
        },
    },
    tpdNotificheAreaRiservata: {
        __mfeName__: "tpdNotificheAreaRiservata",
        devClientPort: 3227,
        devServerPort: 3227,
        mfePriority: 1000,
        portlet: {
            path: "UnipolSai-Disegno-Account / PT_Notifiche_Area_Riservata",
            uniqueName: "unipolsai.areariservata.account.notificheareariservata",
            title: "Notifiche_Area_Riservata",
        },
    },
    tpdEsitoAggiuntaCarta: {
        __mfeName__: "tpdEsitoAggiuntaCarta",
        devClientPort: 3228,
        devServerPort: 3228,
        portlet: {
            path: "UnipolSai-Disegno-Area-Riservata / PT_Esito_Aggiunta_Carta",
            uniqueName: "unipolsai.areariservata.esitoAggiuntaCarta",
            title: "Esito_aggiunta_carta",
        },
    },
    tpdLocatorLiquidazioneSinistri: {
        __mfeName__: "tpdLocatorLiquidazioneSinistri",
        devClientPort: 3236,
        devServerPort: 3236,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Locator_Liquidazione_Sinistri",
            uniqueName: "unipolSai.portlet.locatorLiquidazioneSinistri",
            title: "Locator_Liquidazione_Sinistri",
        },
    },
    tpdRecuperaDocumento: {
        __mfeName__: "tpdRecuperaDocumento",
        devClientPort: 3234,
        devServerPort: 3234,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Recupera_Documento",
            uniqueName: "unipolSai.portlet.recuperaDocumento",
            title: "Recupera_Documento",
        },
    },
    tpdConvertionProspect: {
        __mfeName__: "tpdConvertionProspect",
        devClientPort: 3239,
        devServerPort: 3239,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Convertion_Prospect",
            uniqueName: "unipolSai.portlet.convertionProspect",
            title: "Convertion_Prospect",
        },
    },
    tpdUnitLinked: {
        __mfeName__: "tpdUnitLinked",
        devClientPort: 3240,
        devServerPort: 3240,
        portlet: {
            path: "UnipolSai-Disegno-QuotazioniRendiconti / PT_Unit_Linked",
            uniqueName: "unipolSai.portlet.unitLinked",
            title: "Unit_Linked",
        },
    },
    tpdPagamentoInsoluto: {
        __mfeName__: "tpdPagamentoInsoluto",
        devClientPort: 3242,
        devServerPort: 3242,
        portlet: {
            path: "UnipolSai-Disegno-Area-Riservata / PT_Pagamento_Insoluto",
            uniqueName: "unipolsai.areariservata.pagamento.insoluto",
            title: "",
        },
    },
    tpdDettaglioPolizza: {
        __mfeName__: "tpdDettaglioPolizza",
        devClientPort: 3078,
        devServerPort: 3078,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_dettaglio_polizza",
            uniqueName: "unipolsai.areariservata.polizzewidget.dettagliopolizza",
            title: "Dettaglio_Polizza",
        },
    },
    tpdDettaglioPolizzaCollettiva: {
        __mfeName__: "tpdDettaglioPolizzaCollettiva",
        devClientPort: 3190,
        devServerPort: 3190,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_dettaglio_polizza_collettiva",
            uniqueName: "unipolsai.areariservata.polizzewidget.dettaglioPolizzaCollettiva",
            title: "Dettaglio_Polizza_Collettiva",
        },
    },
    tpdDettaglioPolizzaPrevidenza: {
        __mfeName__: "tpdDettaglioPolizzaPrevidenza",
        devClientPort: 3191,
        devServerPort: 3191,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_dettaglio_polizza_previdenza",
            uniqueName: "unipolsai.areariservata.polizzewidget.dettaglioPolizzaPrevidenza",
            title: "Dettaglio_Polizza_Previdenza",
        },
    },
    tpdDettaglioPolizzaRamiElementari: {
        __mfeName__: "tpdDettaglioPolizzaRamiElementari",
        devClientPort: 3187,
        devServerPort: 3187,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_dettaglio_polizza_rami_elementari",
            uniqueName: "unipolsai.areariservata.polizzewidget.polizzeRamiElementari",
            title: "Polizze_Rami_elementari",
        },
    },
    tpdDocumentazioneTitle: {
        __mfeName__: "tpdDocumentazioneTitle",
        devClientPort: 3023,
        devServerPort: 3023,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Documentazione_Title",
            uniqueName: "unipolSai.portlet.prodottoDocumentazione",
            title: "Documentazione",
        },
    },
    tpdElencoPolizzeVerticale: {
        __mfeName__: "tpdElencoPolizzeVerticale",
        devClientPort: 3085,
        devServerPort: 3085,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_Elenco_Polizze_Verticale",
            uniqueName: "unipolsai.areariservata.polizzewidget.listapolizze",
            title: "Elenco_Polizze_Verticale",
        },
    },
    tpdEsitoRinnovoPolizza: {
        __mfeName__: "tpdEsitoRinnovoPolizza",
        devClientPort: 3194,
        devServerPort: 3194,
        portlet: {
            path: "UnipolSai-Disegno-Polizze / PT_esito_rinnovo_polizza",
            uniqueName: "unipolsai.areariservata.polizze.esitorinnovopolizza",
            title: "Esito_Rinnovo_Polizza",
        },
    },
    tpdRiepilogoPreventivoSticky: {
        __mfeName__: "tpdRiepilogoPreventivoSticky",
        devClientPort: 3044,
        devServerPort: 3044,
        portlet: {
            path: "UnipolSai-Preventivatori-Auto-Moto / PT_Riepilogo_Preventivo_Sticky",
            uniqueName: "unipolSai.portlet.riepilogoPreventivoSticky",
            title: "Riepilogo_Preventivo_Sticky",
        },
    },
    tpdProdottoUnico: {
        __mfeName__: "tpdProdottoUnico",
        devClientPort: 3083,
        devServerPort: 3083,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_tpdInterpreteAngularDxApiPuContainer",
            uniqueName: "unipolsai.portlet.tpdInterpreteAngularDxApiPuContainer",
            title: "tpdInterpreteAngularDxApiPuContainer",
        },
    },
    tpdRecuperoPreventivo: {
        __mfeName__: "tpdRecuperoPreventivo",
        devClientPort: 3037,
        devServerPort: 3037,
        portlet: {
            path: "UnipolSai-Preventivatori-Auto-Moto / PT_Recupero_Preventivo",
            uniqueName: "unipolSai.portlet.recuperaPreventivo",
            title: "Recupera_Preventivo",
        },
    },
    tpdDatiPersonali: {
        __mfeName__: "tpdDatiPersonali",
        devClientPort: 3175,
        devServerPort: 3175,
        portlet: {
            path: "UnipolSai-Disegno-Account / PT_dati_personali",
            uniqueName: "unipolsai.areariservata.account.datipersonali",
            title: "Dati_Personali",
        },
    },
    tpdListingBoxCustomEmpty: {
        __mfeName__: "tpdListingBoxCustomEmpty",
        devClientPort: 3134,
        devServerPort: 3134,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / Generic / PT_Listing_Box_Custom_Empty",
            uniqueName: "unipolSai.portlet.listingBoxCustom",
            title: "Listing_Box_Custom",
        },
    },
    tpdListingBoxCustom: {
        __mfeName__: "tpdListingBoxCustom",
        devClientPort: 3243,
        devServerPort: 3243,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / Generic / PT_Listing_Box_Custom",
            uniqueName: "unipolSai.portlet.lancioCustom",
            title: "Lancio_Dettaglio_Scheda",
        },
    },
    tpdStoricoPagamenti: {
        __mfeName__: "tpdStoricoPagamenti",
        devClientPort: 3258,
        devServerPort: 3258,
        portlet: {
            path: "UnipolSai-Disegno-Area-Riservata / PT_storico_pagamenti",
            uniqueName: "unipolSai.portlet.StoricoPagamenti",
            title: "Storico_Pagamenti",
        },
    },
    tpdMarketingCardPreventivatore: {
        __mfeName__: "tpdMarketingCardPreventivatore",
        devClientPort: 3246,
        devServerPort: 3246,
    },
    tpdCaratteristiche: {
        __mfeName__: "tpdCaratteristiche",
        devClientPort: 3247,
        devServerPort: 3247,
    },
    tpdAltriProdotti: {
        __mfeName__: "tpdAltriProdotti",
        devClientPort: 3248,
        devServerPort: 3248,
    },
    tpdLancioPreventivatori: {
        __mfeName__: "tpdLancioPreventivatori",
        devClientPort: 3249,
        devServerPort: 3249,
    },
    tpdGaranzie: {
        __mfeName__: "tpdGaranzie",
        devClientPort: 3250,
        devServerPort: 3250,
    },
    tpdLancioUnica: {
        __mfeName__: "tpdLancioUnica",
        devClientPort: 3251,
        devServerPort: 3251,
    },
    tpdAmbitiUnica: {
        __mfeName__: "tpdAmbitiUnica",
        devClientPort: 3252,
        devServerPort: 3252,
    },
    tpdDomandeFrequentiInfo: {
        __mfeName__: "tpdDomandeFrequentiInfo",
        devClientPort: 3253,
        devServerPort: 3253,
    },
    tpdPromozionale: {
        __mfeName__: "tpdPromozionale",
        devClientPort: 3254,
        devServerPort: 3254,
    },
    tpdVantaggi: {
        __mfeName__: "tpdVantaggi",
        devClientPort: 3255,
        devServerPort: 3255,
    },
    tpdInformativo: {
        __mfeName__: "tpdInformativo",
        devClientPort: 3257,
        devServerPort: 3257,
    },
    tpdAdobeTargetContainer: {
        __mfeName__: "tpdAdobeTargetContainer",
        devClientPort: 3245,
        devServerPort: 3245,
        mfePriority: 1900,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Adobe_Target",
            uniqueName: "unipolSai.portlet.adobeTarget",
            title: "Contenitore_Adobe_Target",
        },
    },
    tpdEsempiUnica: {
        __mfeName__: "tpdEsempiUnica",
        devClientPort: 3260,
        devServerPort: 3260,
    },
    tpdSetInformativi: {
        __mfeName__: "tpdSetInformativi",
        devClientPort: 3261,
        devServerPort: 3261,
    },
    tpdPreventivatorePrevidenzaContainer: {
        __mfeName__: "tpdPreventivatorePrevidenzaContainer",
        devClientPort: 3262,
        devServerPort: 3262,
        portlet: {
            path: "UnipolSai-Disegno-Area-Pubblica / PT_Lancio_Preventivatore_Previdenza",
            uniqueName: "unipolSai.portlet.PreventivatorePrevidenzaContainer",
            title: "Preventivatore_Previdenza",
        },
    },
    tpdPrendiAppuntamento: {
        __mfeName__: "tpdPrendiAppuntamento",
        devClientPort: 3263,
        devServerPort: 3263
    }
});
exports.PRIMARY_CONTAINER_REMOTES_SETTINGS = settings;
